import React from "react";
import Cummunity from "../components/CommunityComponents/Cummunity";
import CommunityHeader from "../components/CommunityComponents/CommunityHeader";
import Purchasenft from "../components/CommunityComponents/Purchasenft";
import Pixnft from "../components/CommunityComponents/Pixnft";

export default function Communitypage() {
  return (
    <div>
      <CommunityHeader />
      <Cummunity />
      <Pixnft />
      <Purchasenft />
    </div>
  );
}
